import React from "react"

const WizardBanner = ({ wizardMeta }) => {
  const { activityIndex, total, name } = wizardMeta
  return (
    <div className="wizard-banner">
      {`Activity ${activityIndex + 1} of ${total} - ${name}`}
    </div>
  )
}

export default WizardBanner
